import React from "react";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "context/NotificationContext";
// import { useNotifications } from "contexts/NotificationContext";

const PopupNotification: React.FC = () => {
  const { notifications } = useNotifications();

  const navigate = useNavigate();

  const handleRedirect = (notification: any) => {
    // Mark as read before navigation
    // markAsRead(notification.id);

    switch (notification.type) {
      case "Prosecutor_Dicipline_Service.ComplaintReception":
        navigate(`/compliant-request/${notification.related_id}`);
        break;
      default:
        navigate("/");
    }
  };

  // if (connectionStatus === "error") {
  //   return (
  //     <div className="fixed top-20 right-10 z-50 max-w-sm bg-red-50 border border-red-300 shadow-lg rounded-lg p-4">
  //       <p className="text-red-700 font-medium">Error: {error}</p>
  //     </div>
  //   );
  // }

  // if (connectionStatus === "disconnected") {
  //   return (
  //     <div className="fixed top-20 right-10 z-50 max-w-sm bg-yellow-50 border border-yellow-300 shadow-lg rounded-lg p-4">
  //       <p className="text-yellow-700 font-medium">
  //         Disconnected. Please refresh your page.
  //       </p>
  //     </div>
  //   );
  // }

  const unreadNotifications = notifications.filter(
    (n: any) =>
      !n.is_read &&
      n.type === "Prosecutor_Dicipline_Service.ComplaintReception",
  );
  const latestUnread = unreadNotifications.sort(
    (a: any, b: any) =>
      new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
  );

  if (latestUnread.length === 0) {
    return (
      <div className="fixed top-20 right-10 z-50 max-w-sm bg-white border shadow-md rounded-lg p-4">
        <p className="text-gray-500">No new notifications</p>
      </div>
    );
  }

  return (
    <div className="fixed top-20 right-10 z-50 w-96 bg-white border shadow-xl rounded-xl p-4 space-y-3 max-h-[80vh] overflow-y-auto">
      {latestUnread.map((n: any) => (
        <div
          key={n.id}
          className="relative bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-md p-3 cursor-pointer transition"
          onClick={() => handleRedirect(n)}
        >
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <p className="text-sm font-semibold text-gray-800">
                New Notification
              </p>
              <p className="text-sm text-gray-600 mt-1">{n.message}</p>
              {n.timeAgo && (
                <p className="text-xs text-gray-400 mt-1">{n.timeAgo} ago</p>
              )}
            </div>
            <button
              // onClick={(e) => {
              //   e.stopPropagation(); // Prevent navigation on 'X' click
              //   markAsRead(n.id);
              // }}
              className="text-gray-400 hover:text-gray-600"
            >
              <X size={16} />
            </button>
          </div>
          {/* {n.type && (
            <span className="absolute top-2 right-8 inline-block text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full capitalize">
              {n.type}
            </span>
          )} */}
        </div>
      ))}
    </div>
  );
};

export default PopupNotification;
